/**
 * ヘルプ本文の描画。**生の HTML は通さない。**
 *
 * `react-markdown` は既定で HTML を素通ししないので、そのまま使う
 * （`rehype-raw` のような差し込みは入れない）。表と取り消し線のために
 * `remark-gfm` だけを足している。
 *
 * `##` / `###` の見出しには、文字列から作った id を付ける（`help-anchor.ts`）。
 * 画面の「?」が、ドロワーを開いたあとにその見出しまで送るための錨である。
 */

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { rehypeHeadingIds } from "./help-anchor";

export function HelpBody({ body }: { body: string }) {
  return (
    <div className="vd-help-body">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeHeadingIds]}
      >
        {body}
      </ReactMarkdown>
    </div>
  );
}
